import { ReservationType } from "@/features/bookings/types/types";

export const reservationTypesLabels = {
  [ReservationType.PAST]: "bookings.past",
  [ReservationType.UPCOMING]: "bookings.upcoming",
  [ReservationType.REFUNDED]: "bookings.cancelled",
};
